(function (Drupal, $, settings) {

  Drupal.behaviors.foodMenu = {
    attach: function attach(context) {
      const $activeMenuItem = $('.homepage-menu-category .horizontal .is-active');

      if ($activeMenuItem.length) {

        let scrollToAction = () => {

          if ($(".views-view-grid.horizontal.cols-3").css('overflow-x') === 'auto') {
            $activeMenuItem[0].scrollIntoView(
              {
                behavior: 'instant',
                inline: 'center'
              }
            );
          }
        }


        function debounce(func) {
          var timer;
          return function (event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 100, event);
          };
        }

        window.addEventListener("resize", debounce(function (e) {
          scrollToAction();
        }));

        scrollToAction();

      }
    }
  }
})(Drupal, jQuery, drupalSettings);
